import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';


const ModuleTabs = (props) => {
   const navigate = useNavigate();
   const params = useParams();
   const [moduleName, setModuleName] = useState("");
   const UUID = params?.uuid;
   const location = useLocation();
   const locationData = location.state || {};
   if(!locationData?.actionMode) navigate("/dashboard/xr");
   const Child = props.ChildComponent;
   const { tabName, type } = props;

   const handleTabSelect = (selectedTab) => {
      if(selectedTab == "back"){
         navigate("/dashboard/xr")
      }else if(type === "XR"){
            navigate(`/dashboard/xr/${selectedTab}/${UUID}`, { state: { name: moduleName, type: "MODULE", actionMode: locationData.actionMode } });
      }
   };

   useEffect(() => {
      setModuleName(locationData?.name || "")
   }, [locationData])

   return (
      <>
         <div className='filterhere'>

            <Tabs
               activeKey={tabName}
               onSelect={handleTabSelect}
            >
               <Tab title={<span> <i className="bi-chevron-left"></i> Back </span>} eventKey="back" />  
               <Tab className='tabb' eventKey="details" title="Basic Details" /> 
               <Tab eventKey="assets" title="Upload Assets" />  
               {type === "XR" && <Tab eventKey="tasklist" title="Tasklist" /> }
               {type === "XR" && <Tab eventKey="quiz" title="Quiz" /> }
               {type === "XR" && <Tab eventKey="sop" title="SOP" /> }
               {type === "XR" && <Tab eventKey="criteria" title="Passing Criteria" />   }
               {type === "XR" && <Tab eventKey="video" title="Video" /> }
               {type === "XR" && <Tab eventKey="channels" title="Publish" />}
               {type === "XR" && <Tab eventKey="languages" title="Languages" />}
            </Tabs>
         </div>
         <div className='allcompages'>
            <Child {...props}></Child>
         </div>
      </>
   )
}
export default ModuleTabs;